<template>
    <div id="cesiumContainer"></div>
</template>
<script>
import * as Cesium from "cesium/Cesium";
import widgets from "cesium/Widgets/widgets.css";
import util from "../../components/util"
export default {
    data () {
        return {

        }
    },
    mounted () {
     this.init()
    },
    methods : {
        init () {
              let viewer = util.getViewer("cesiumContainer",{
                  infoBox: true,
                  selectionIndicator: true,
              });
            var lat = 39.940166;
            var lon = 116.400244;

            /*
            流动纹理线
             color 颜色
             duration 持续时间 毫秒
          */
            function PolylineTrailLinkMaterialProperty(color, duration) {
                this._definitionChanged = new Cesium.Event();
                this._color = undefined;
                this._colorSubscription = undefined;
                this.color = color;
                this.duration = duration;
                this._time = (new Date()).getTime();
            }
            Object.defineProperties(PolylineTrailLinkMaterialProperty.prototype, {
                isConstant: {
                    get: function () {
                        return false;
                    }
                },
                definitionChanged: {
                    get: function () {
                        return this._definitionChanged;
                    }
                },
                color: Cesium.createPropertyDescriptor('color')
            });
            PolylineTrailLinkMaterialProperty.prototype.getType = function (time) {
                return 'PolylineTrailLink';
            }
            PolylineTrailLinkMaterialProperty.prototype.getValue = function (time, result) {
                if (!Cesium.defined(result)) {
                    result = {};
                }
                result.color = Cesium.Property.getValueOrClonedDefault(this._color, time, Cesium.Color.WHITE, result.color);
                result.image = Cesium.Material.PolylineTrailLinkImage;
                result.time = (((new Date()).getTime() - this._time) % this.duration) / this.duration;
                return result;
            }
            PolylineTrailLinkMaterialProperty.prototype.equals = function (other) {
                return this === other ||
                    (other instanceof PolylineTrailLinkMaterialProperty &&
                        Property.equals(this._color, other._color))
            }
            Cesium.PolylineTrailLinkMaterialProperty = PolylineTrailLinkMaterialProperty;
            Cesium.Material.PolylineTrailLinkType = 'PolylineTrailLink';
            Cesium.Material.PolylineTrailLinkImage = "img/colors1.png";
            Cesium.Material.PolylineTrailLinkSource = "czm_material czm_getMaterial(czm_materialInput materialInput)\n\
                                                      {\n\
                                                           czm_material material = czm_getDefaultMaterial(materialInput);\n\
                                                           vec2 st = materialInput.st;\n\
                                                           vec4 colorImage = texture2D(image, vec2(fract(st.s - time), st.t));\n\
                                                           material.alpha = colorImage.a * color.a;\n\
                                                           material.diffuse = (colorImage.rgb+color.rgb)/2.0;\n\
                                                           return material;\n\
                                                       }";
            Cesium.Material._materialCache.addMaterial(Cesium.Material.PolylineTrailLinkType, {
                fabric: {
                    type: Cesium.Material.PolylineTrailLinkType,
                    uniforms: {
                        color: new Cesium.Color(1.0, 0.0, 0.0, 0.5),
                        image: Cesium.Material.PolylineTrailLinkImage,
                        time: 0
                    },
                    source: Cesium.Material.PolylineTrailLinkSource
                },
                translucent: function (material) {
                    return true;
                }
            });
            let entity = viewer.entities.add({
                name: 'PolylineTrail',
                polyline: {
                    positions: Cesium.Cartesian3.fromDegreesArrayHeights([116.424966,39.907187,0,
                        116.424535,39.914382, 0,
                        116.362875,39.913275, 0,
                        116.362156,39.946251, 0,
                        116.378972,39.946583, 0,
                        116.380697,39.905969, 0,
                        116.403981,39.906744, 0,
                        116.424966,39.907187,0,]),
                    width: 5,
                    material: new Cesium.PolylineTrailLinkMaterialProperty(Cesium.Color.PURPLE, 3000)
                }
            });

            viewer.zoomTo(entity);

         }
    }
}
</script>
<style scoped>
  #cesiumContainer {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
</style>
